/*
*/

export default {

  computed: {

    isDesktop() {
      return this.$store.getters.isDesktop;
    },

    isMobile() {
      return this.$store.getters.isMobile;
    },

    isTablet() {
      return this.$store.getters.isTablet;
    },

    isReversed() {
      const { reversed } = this.data;
      return (reversed === true) ? reversed : false;
    },

    currentWidth() {
      return this.$store.state.width;
    },

    deviceType() {
      let deviceStr = '';
      if (this.isMobile) {
        deviceStr = 'mobile';
      } else if (this.isTablet) {
        deviceStr = 'tablet';
      } else {
        deviceStr = 'desktop';
      }
      return deviceStr;
    },

  },

};



// WEBPACK FOOTER //
// ./src/mixins/responsive-mixin.js